module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"information":"Informationen","edit":"Bearbeiten","save":"Speichern","text":"Bitte geben Sie einen Text ein…","back":"Zurück"},"en":{"information":"Information","edit":"Edit","save":"Save","text":"Please enter some text","back":"Back"}}')
  delete Component.options._Ctor
}
